import { VueModule } from '@Foundation/utilities';
import MikmakModule from './code/Scripts/components/mikmak-module.vue';

export default VueModule({
    components: {
        MikmakModule
    }
})